module.exports = "https://static.zego.com/_next/static/images/founder-sten-89063bd2fe5d5afc90f44446d21d0fcb.jpg";